module.exports = __webpack_public_path__ + "img/Question-bg-1.1f928c42.png";